import {useRef, useState} from 'react'
import http from '@/biz/http.mjs'
import normalizeUrl from '@/biz/normalizeUrl.mjs'
import runAsync from '@/script/runAsync.mjs'

export const useAi = ({
    compactView = false,

    defaultDraft: {
        content: defaultDraftContent = '',
        files: defaultDraftFiles = [],
    } = {},

    maxFileCount = 50,
}) => {
    const [draft, setDraft] = useState({
        content: defaultDraftContent,

        files: defaultDraftFiles.map(f => {
            if (f.fileId) {
                const src = normalizeUrl(`/files/${f.fileId}`)
                return {...f, src}
            }
            else {
                return f
            }
        }),
    })

    const [isDisabled, setIsDisabled] = useState(false)
    const [isRunning, setIsRunning] = useState(false)
    const [messages, setMessages] = useState([])
    const refAbortController = useRef()

    return {
        compactView,
        draft,
        maxFileCount,
        messages,
        setDraft,
        setIsDisabled,
        setIsRunning,
        setMessages,

        addMessage(message) {
            const id = crypto.randomUUID()
            this.messages = [...this.messages, {...message, id}]
            this.setMessages(this.messages)
            return id
        },

        getIsDisabled() {
            return isDisabled
        },

        getIsReady() {
            return true
        },

        getIsRunning() {
            return isRunning
        },

        getLastMessage() {
            return this.messages.at(-1)
        },

        async run() {
            refAbortController.current = new AbortController
            this.setIsRunning(true)
            this.setDraft({content: '', files: []})
        },

        stop() {
            refAbortController.current?.abort()
            this.setIsRunning(false)
        },

        updateMessage(id, fn) {
            const i = this.messages.findIndex(e => e.id === id)

            if (- 1 < i) {
                const updatedMessage = fn(this.messages[i])
                this.messages =  this.messages.with(i,  updatedMessage)
                this.setMessages(this.messages)
            }
        },

        _getSignal() {
            return refAbortController.current?.signal
        },

        async _uploadDraftFiles() {
            return runAsync(
                () => Promise.all(
                    this.draft.files.map(file => {
                        if (file.fileId) {
                            const {fileId, name, size} = file

                            return {
                                fileId,
                                originalFileName: name,
                                len: size,
                            }
                        }
                        else {
                            return http.upload(
                                {file, pathName: 'tmp'},
                                {signal: this._getSignal()}
                            )
                        }
                    })
                ),

                {action: '上传文件'}
            )
        }
    }
}
